<template>
  <!-- 12px title-to-card per design; scroll-mt keeps anchor landings clear of the status bar -->
  <div class="flex flex-col gap-3 anchor-scroll-margin">
    <!-- Gens H3: AktivGrotesk-Bold 24/32, grey-90 -->
    <h2
      v-if="section.title"
      class="font-aktiv-grotesk-bold text-[24px] leading-8 text-[#21252C]"
      style="
        font-feature-settings:
          'liga' off,
          'clig' off;
      "
    >
      {{ section.title }}
    </h2>

    <!-- Single card: no carousel, no dots — same 300×200 size as carousel cards -->
    <div v-if="cards.length === 1" class="w-[300px]">
      <MoreBannerCard :card="cards[0]" @card-click="$emit('card-click', $event)" />
    </div>

    <BaseCarousel
      v-else
      ref="carousel"
      :title="carouselId"
      :item-width="316"
      :mobile-item-width="316"
      :no-of-items="cards.length"
      show-dots
    >
      <MoreBannerCard
        v-for="card in cards"
        :key="card.id"
        :card="card"
        class="pr-4"
        @card-click="$emit('card-click', $event)"
      />
    </BaseCarousel>
  </div>
</template>

<script>
import BaseCarousel from '@/components/ResourcesPage/PlaybackResources/BaseCarousel.vue';
import MoreBannerCard from '@/components/MorePage/MoreBannerCard.vue';

export default {
  name: 'MoreCardSection',
  components: { BaseCarousel, MoreBannerCard },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  emits: ['card-click'],
  computed: {
    carouselId() {
      // Glider needs a DOM-unique id per carousel; fall back to the title
      // slug so a missing id can't produce duplicate DOM ids
      const key =
        this.section?.id ?? (this.section?.title || 'section').toLowerCase().replace(/\W+/g, '-');
      return `more-cards-${key}`;
    },
    cards() {
      // No order field on more-card — Strapi preserves the admin drag order
      return this.section.cards || [];
    },
  },
  methods: {
    // Called by the page's ionViewWillEnter — Ionic re-shows cached pages
    // without remounting, so Glider must re-measure.
    refresh() {
      this.$refs.carousel?.refresh();
    },
  },
};
</script>
